<template>
  <v-container class="mb-8">
    <v-alert
      flat
      type="warning"
      elevation="4"
      v-if="application_check && application_check.messege_reject"
    >
      <p class="font-weight-light title">Комментарий оператора:</p>
      {{application_check.messege_reject}}
    </v-alert>
    <v-card
      class="d-flex flex-row mb-6"
      flat
      v-if="application_check && application_check.abiturient"
    >
      <v-card
        width="50%"
        flat
      >
        <v-card-title class="display-1">{{application_check.abiturient.last_name}} {{application_check.abiturient.first_name}}</v-card-title>
        <v-card-text>
          <ul>
            <li>Телефон: <span class="font-weight-medium">{{application_check.abiturient.phone}}</span></li>
            <li>Доп. телефон: <span class="font-weight-medium">{{application_check.abiturient.phone_additional}}</span></li>
            <li>Эл. почта: <span class="font-weight-medium">{{application_check.abiturient.email}}</span></li>
          </ul>
        </v-card-text>
        <v-btn class="mx-2 mb-2" color="primary" right v-on:click="savePdfAbitData(application_check.id)">Сохранить в PDF</v-btn>
      </v-card>

      <v-card
        width="50%"
        flat
      >
        <v-card-title class="display-1">Заявление № {{application_check.id}}</v-card-title>
        <v-card-text>
          <ul>
            <li><span class="font-weight-medium">{{application_check.campaign.name}}</span></li>
            <li>Тип заявления: <span class="font-weight-medium">{{application_check.application_type.name}}</span></li>
          </ul>
        </v-card-text>
      </v-card>
    </v-card>
    <v-card
      class="d-flex flex-row mb-6"
      flat
      v-if="application_check && application_check.abiturient &&  application_check.abiturient.file"
    >
      <v-card
        width="50%"
        flat
      >
        <v-card-title class="text-center">Файлы с персональными данными</v-card-title>
        <div v-for="(data, index) in application_check.abiturient.file"
             :key="index">
          <v-chip
            v-if="data.type === 1 || data.type === 2 ||data.type === 3 ||data.type === 4"
            label
            small
            class="ma-2"
            :color="color[data.type]"
            text-color="white"
            link
            :href="data.url"
            target="_blank"
          >
            {{ n[data.type] }} ({{data.datetime}})  <!--TEST-->
          </v-chip>
        </div>
      </v-card>

      <v-card
        width="50%"
        flat
      >
        <v-card-title class="text-center">Файлы с информацией о заявлении</v-card-title>

        <div v-for="(data, index) in application_check.abiturient.file"
             :key="index">
          <v-chip
            v-if="data.type !== 1 && data.type !== 2 && data.type !== 3 && data.type !== 4 && data.type !== 100"
            label
            small
            class="ma-2"
            :color="color[data.type]"
            text-color="white"
            link
            :href="data.url"
            target="_blank"
          >
            {{ n[data.type] }} ({{data.datetime}})  <!--TEST-->
          </v-chip>
        </div>
      </v-card>
    </v-card>

    <v-row class="px-2 mt-10" v-if="application_check">
      <v-btn color="success" class="mr-2" v-on:click="saveFiles(application_check.abiturient.id, application_check.id)">Сохранить все файлы в архиве</v-btn>
      <send_contract v-if="user.is_superuser ===true" v-bind:application=application_check></send_contract>
      <v-spacer></v-spacer>
      <messege_done v-bind:application_id=application_check.id></messege_done>
      <messege_reject :application_id=application_check.id :messege=application_check.messege_reject></messege_reject>
    </v-row>
    <v-row class="px-2 mt-10 mb-3" v-if="application_check">
      <Messege_isClose :application_id=application_check.id :messege=application_check.messege_reject></Messege_isClose>
    </v-row>


    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex'
  import {mdiAlertCircleOutline} from '@mdi/js'
  import messege_reject from "@/components/operator/messege_reject.vue";
  import send_contract from "@/components/operator/send_contract.vue";
  import messege_done from "@/components/operator/messege_done.vue"
  import Messege_isClose from "../../components/operator/messege_isClose";

  export default {
    name: "CheckApplication",
    data: () => ({
      overlay: false,
      mdiAlertCircleOutline,
    }),
    methods: {
      saveFiles: function (abiturient, application) {
        this.overlay = true;
        Vue.axios.get('operator/download/', {
          params:{abiturient,application},
          responseType: 'blob'
          },
        ).then(response => {
          this.overlay=false;
          let blob = new Blob([response.data], {type: 'application/zip'}),
            url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = 'Прикрепленные документы_Заявление_' + application + '.zip';
          a.click();
        });
      },
      savePdfAbitData: function (application) {
        Vue.axios.get('operator/savePdf/' + application, {
          responseType: 'blob'
          },
        ).then(response => {
          let blob = new Blob([response.data],
            {type: 'application/pdf'}),
            url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = 'Информация об абитуриенте_Заявление_' + application + '.pdf';
          a.click();
        });
      },
    },
    computed: {
      ...mapGetters("operator", ["application_check"]),
      ...mapGetters("auth", ["user"]),

      color: function () {
        const list2 = {1:'light-green lighten-1', 2:'light-green lighten-1', 3:'light-green lighten-1',
          4:'light-green lighten-1', 5:'light-green lighten-1', 6:'light-green lighten-1',
          7:'light-green lighten-1', 8:'light-green lighten-1', 9:'light-green lighten-1',
          10:'light-green lighten-1', 11:'light-green lighten-1', 12:'light-green lighten-1',
          13:'light-green lighten-1', 14:'light-green lighten-1', 15:'light-green lighten-1', 99:'red lighten-1',
        104:'blue lighten-1',105:'blue lighten-1',150:'purple',151:'purple',152:'purple'
        ,153:'purple',154:'purple',155:'purple'};

        return list2
      },
      n: function () {
        const  list={};
        for (let i=0; i<this.application_check.abiturient.file[0].TYPE_CHOICES.length; i++)
        {
          list[this.application_check.abiturient.file[0].TYPE_CHOICES[i][0]] = this.application_check.abiturient.file[0].TYPE_CHOICES[i][1];
        }
        return list;
      },
    },
    components: {
      Messege_isClose,
      messege_reject,
      send_contract,
      messege_done,
    },
    beforeCreate() {
      this.$store.dispatch('operator/loadApplicationsCheck', this.$route.params);
    },
  }
</script>

<style scoped>
</style>
